module.exports = __webpack_public_path__ + "static/media/peds-superhero@3x.8602c924.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/peds-superhero@3x.png
// module id = 1747
// module chunks = 0